import { flow, get, keyBy, map, mapValues, upperCase } from 'lodash/fp';

const mapCategories = map(({ id, abbreviation, name }) => ({
  id,
  abbr: abbreviation,
  shortName: name,
  name
}));

function mapAndFilterCategories(categories) {
  const fields = [];

  Object.entries(categories).forEach(([id, category]) => {
    fields.push({
      id,
      ...category
    });
  });

  return mapCategories(fields);
}

function mapOverview(overview) {
  const items = [];

  Object.entries(overview).forEach(([id, item]) => {
    items.push({
      id,
      label: upperCase(id),
      stats: item
    });
  });

  return items;
}

function mapLogs({ log, tour }) {
  return map(item => ({
    stats: item,
    tour: upperCase(tour)
  }))(log);
}

const mapStats = flow(keyBy('id'), mapValues('value'));

const mapGames = games => {
  games.sort((game1, game2) => new Date(game2.start_time) - new Date(game1.start_time));

  return games.map(game => ({
    id: game.id,
    score: get('score', game),
    startTime: get('start_time', game),
    stats: mapStats(game.stats)
  }));
};

function decodePlayerSeasonStats(data) {
  return mapValues(fn => fn(data), {
    averageScore: get('season_player.aggregates.overall.average_score'),
    categories: flow(get('season_player.season.labels'), mapAndFilterCategories),
    seasonId: get('season_player.season.id'),
    seasonName: get('season_player.season.name'),
    entityId: get('season_player.player.id'),
    games: flow(get('season_player.competitions'), mapGames),
    highScore: get('season_player.high_score_competition.score'),
    logs: flow(get('season_player.season'), mapLogs),
    maxScore: get('season_player.season.competition.competition_type.max_onescore'),
    playerName: get('season_player.player.name'),
    overview: flow(get('season_player.season.overview'), mapOverview),
    positionAbbr: get('season_player.position.abbreviation'),
    positionName: get('season_player.position.name'),
    sportId: get('season_player.season.competition.competition_type.sport.id'),
    teamAbbr: get('season_player.player_team.abbreviation'),
    teamId: get('season_player.player_team.id'),
    teamName: get('season_player.player_team.name'),
    news: get('season_player.player.news')
  });
}

export default decodePlayerSeasonStats;
